import { createContext } from 'react'


const viewerContext = createContext({

  // rotationCircle => viewer，指当前rotationCircle的值需要反映到Viewer上
  rotationDegree: 0,

  setRotationDegree: (degree) => {},

})
viewerContext.displayName = "viewerContext"

export default viewerContext